import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const IndividualPassageSearchService = {
    providers: async () => axios.get(`${API_KEEPER}/individual/providers`)
        .then(({data}) => data
            .filter(item => Boolean(item.name?.trim()))
            .map(item => ({value: item.id, label: item.name, type: item.type}))
        )
        .catch((err) => { throw err }),

    facialRecognitionStatus: async () => axios.get(`${API_KEEPER}/facial-recognition/status`)
        .then(({data}) => data === true || data === "true")
        .catch(() => false),

    search: async (formData) => axios.post(`${API_KEEPER}/individual-passage-search`, formData)
        .then(({data}) => data)
        .catch((err) => { throw err }),

    snapshot: async (eventDateTime, cameraId) => axios.get(`${API_KEEPER}/individual-passage-search/snapshot/${eventDateTime}/${cameraId}`)
        .then(({data}) => data)
        .catch(() => undefined),
};

export default IndividualPassageSearchService;
